<template>
<div>
  <div class="d-flex" id="wrapper">
    <SideBar />
    <div id="page-content-wrapper">
      <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
        <div>
          <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
          </button>

          <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
             <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
          </button>
        </div>
        <div class="d-flex">
          <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
          <p class="text-primary mb-0 hover-cursor">&nbsp;Upgrade - Downgrade Unit</p>
        </div>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ admin }}
              </a>
              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
              </div>
            </li>
          </ul>
        </div>
      </nav>
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 grid-margin stretch-card card-div">
            <div class="container">
              <h5 class="card-title mb-4">Upgrade / Downgrade Unit</h5>
              <div class="col-lg-12 px-0">
                <div class="container">
                  <div class="row">
                    <div class="col-lg-4 col-sm mobile-div pl-0">
                      <div>Nama Perusahaan</div>
                      <!-- <multiselect v-model="selectedCompany" :options="companyList" label="companyName" :allow-empty="false" deselect-label="Can't remove this value" :searchable="true" @search-change="searchCompany" :loading="isLoading" placeholder="Nama Perusahaan" aria-placeholder="Nama Perusahaan">
                        <span slot="noOptions"></span>
                      </multiselect> -->
                      <input type="text" class="form-control-lg" name="unique_value" placeholder="Company Name" v-model="selectedCompany">
                    </div>
                    <div class="col-lg-3 col-sm mobile-div pl-0">
                      <div>Unique ID</div>
                      <input type="text" class="form-control-lg" name="unique_value" placeholder="SN/SC" v-model="uniqueId">
                    </div>
                    <div class="col-lg-3 col-sm mobile-div pl-0">
                      <div>Order ID</div>
                      <input type="text" class="form-control-lg" name="id_value" placeholder="Order ID" v-model="orderCode">
                    </div>
                    <div class="col-lg-2 px-0 col-sm mobile-div mt-4">
                      <div class="container">
                        <div class="row align-items-center">
                          <button class="btn btn-primary" @click="searchData"> Search </button>
                          <button class="btn btn-info w-50 ml-1" @click="resetSearch"> Reset </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <button class="btn btn-primary mt-3" @click="toPage('/rental/upgrade/create')">Create</button>
              </div>
              <table class="table table-sm table-bordered table-striped table-responsive-sm mt-5">
                <thead>
                  <tr>
                    <th>Nama Perusahaan</th>
                    <th>Order ID</th>
                    <th>Kode Produk / Serial Number</th>
                    <th>Created</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="loadingTable == true">
                    <td colspan="6" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                  </tr>
                  <tr v-else-if="loadingTable == false" v-for="(item,i) in dataTable" :key="i">
                    <td>{{item.companyName}}</td>
                    <td>{{item.orderId}}</td>
                    <td>{{item.lpSn}}</td>
                    <td>{{item.created}}</td>
                    <td>{{item.status}}</td>
                    <td>
                      <div class="container">
                        <div class="row justify-content-center">
                          <button class="btn btn-sm btn-info mx-1" @click="toDetail(item)">Detail</button>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="dataTable.length == 0 && loadingTable == false">
                    <td colspan="5" class="text-center"> Data Not Available</td>
                  </tr>
                </tbody>
              </table>
              <div id="wrapperr">
                <div id="c1" style="display: inline-flex;" class="align-items-center">
                  <div style="margin-right: 10px;">
                    <select class="form-control form-control-sm" v-model="itemPerPage" @change="searchData">
                      <option :value="10">10</option>
                      <option :value="40">40</option>
                      <option :value="80">80</option>
                    </select>
                  </div>
                  <div class="alignLeft total-data">
                    Total Data {{ totalData }}
                  </div>
                </div>
                <div id="c2" v-if="totalPage > 0">
                  <div class="pagination p8 alignRight">
                    <ul>
                      <a class="is-active link" @click="toDataPage(page-1)" v-if="page != 0">
                        <li>{{'<'}} </li> 
                      </a> 
                      <a class="page">
                        <li class="text-light">{{ page + 1 }} of {{ totalPage }} page</li>
                      </a>
                      <a class="is-active link" @click="toDataPage(page + 1)" v-if="page + 1 < totalPage">
                        <li>></li>
                      </a>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
</div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import SideBar from '../SideBar'
export default {
  name: 'UpgradeUnit',
  components: {
    SideBar,
    Multiselect
  },
  data() {
    return {
      spaceRegex : /[\u00A0\uFEFF\u202F]/g, 
      uniqueId: '',
      orderCode: '',
      selectedCompany: '',
      companyName: '',
      isLoading: false,
      loadingTable: false,
      dataTable: [],
      companyList: [],
      admin: '',
      adminId: '',
      itemPerPage: 10,
      page: 0,
      totalData: 0,
      totalPage: 0,
      companies: [],
      companyCreate: '',
      selectCatalog: '',
      catalogData: [],
      createSn: '',
      createLp: '',
      warehouseList: [],
      warehouseCreate: '',
      createPrice: '',
      catalogVariants: [],
      varianSelect: '',
      varianSearch: '',
      permission: ''
    }
  },
  methods: {
    submitCreate() {
      this.$http.post(process.env.CREATE_UPGRADE, {
          companyId: this.companyCreate.companyId,
          orderDetailsId: this.selectCatalog.orderDetailsId,
          orderLp: this.selectCatalog.code,
          orderSn: this.selectCatalog.sn,
          productId: this.varianSelect.catalogId,
          price:this.createPrice !== null ? parseInt(this.createPrice.replace(this.spaceRegex, ' ')) : parseInt(this.createPrice)

        }, { headers: { "Asani-Token": localStorage.getItem("jwt") } })
        .then(res => {
          if (res.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            })

          } else {
            swal("Success", 'Berhasil', "success", {
              button: "Ok",
            })
            window.location.reload()
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    getVariant() {
      this.$http.post(process.env.GET_CATALOG_VARIAN, {
          catalogName: this.varianSelect,
        }, { headers: { "Asani-Token": localStorage.getItem("jwt") } })
        .then(res => {
          console.log(res)
          if (res.data.status == 200) {
            this.catalogVariants = res.data.content
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    resetCreate() {
      this.selectCatalog = ''
      this.createSn = ''
      this.createLp = ''
      this.createPrice = ''
      this.companyCreate = ''
    },
    openModalCreate() {
      $('#modalCreateUpgrade').modal('show')
      this.getVariant()
    },
    toDataPage(val) {
      this.page = val
      window.scrollTo(0, 0)
      localStorage.setItem('upgrade-cache', JSON.stringify({ itemPerPage: this.itemPerPage, page: this.page, companyName: this.companyName, uniqueId: this.uniqueId, orderCode: this.orderCode }))
      window.location.reload()
    },
    resetSearch() {
      this.companyName = ''
      this.selectedCompany = ''
      this.uniqueId = ''
      this.orderCode = ''
      this.searchData()
    },
    searchData() {
      this.$http.post(process.env.SEARCH_UPGRADE, {
          "companyName": this.companyName.replace(this.spaceRegex,' '),
          "orderCode": this.orderCode.replace(this.spaceRegex,' '),
          "uniqueId": this.uniqueId.replace(this.spaceRegex,' '),
          "itemPerPage": this.itemPerPage,
          "page": +this.page + 1
        }, { headers: { "Asani-Token": localStorage.getItem("jwt") } })
        .then(res => {
          if (res.data.status == 200) {
            this.dataTable = res.data.content.data
            this.loadingTable = false
            this.page = res.data.content.currentPage - 1
            this.totalData = res.data.content.totalData
            this.totalPage = res.data.content.totalPage
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    searchCompany(query) {
      if (query.length > 2) {
        this.isLoading = true
        this.$http.post(process.env.SEARCH_COMPANY, {
            companyName: query
          }, {
            headers: { "Asani-Token": localStorage.getItem("jwt") }
          })
          .then(res => {
            this.isLoading = false
            console.log(res)
            if (res.data.status == 200) {
              if (Array.isArray(res.data.data[0])) {
                this.companyList = []
              } else {
                this.companyList = res.data.data
              }
            }
          })
          .catch(error => {
            this.isLoading = false
            swal("Sorry", error.response.data.message, "error", {
              button: "Ok",
            }).then(v => {
              if(error.response.data.status == 401) {
                this.handleLogout()
              }
            })
          })
      }
    },
    toDetail(payload) {
      let companyId = ''
      this.companies.forEach(el => {
        if (payload.companyName == el.companyName) {
          companyId = el.companyId
        }
      })
      // console.log(companyList)
      this.$router.push('/rental/upgrade/detail/' + payload.id + '?companyId=' + companyId)
    },
    toPage(e) {
      this.$router.push(e)
    },
    sidebar() {
      $("#wrapper").toggleClass("toggled");
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
      localStorage.removeItem('jwt')
      localStorage.removeItem('admin_name')
      localStorage.removeItem('roles')
      localStorage.removeItem('user_email')
      localStorage.removeItem('admin_id')
      localStorage.removeItem('qc-cache')
      localStorage.removeItem('changeCatalogPermission')
      this.$router.push('/')
    },
    cekLogin() {
      if (localStorage.getItem('jwt') == null) {
        this.$router.push('/')
        localStorage.removeItem('qc-cache')
      }
    },
    cekPermission() {
      this.permission = localStorage.getItem('roles').replace(/"/g, "").replace("[", "").replace("]", "").split(",")
      for (var i = 0; i < this.permission.length; i++) {
        if (this.permission[i] == "1") {
          this.viewDashboard = true
        }
        if (this.permission[i] == "2.1") {
          this.viewOrder = true
        }
        if (this.permission[i] == "2.2") {
          this.editOrder = true
        }
        if (this.permission[i] == '3.1') {
          this.viewReturn = true
        }
        if (this.permission[i] == '3.2') {
          this.editReturn = true
        }
        if (this.permission[i] == '4.1') {
          this.viewProduct = true
        }
        if (this.permission[i] == '4.2') {
          this.editProduct = true
        }
        if (this.permission[i] == '5.1') {
          this.viewPairing = true
        }
        if (this.permission[i] == '5.2') {
          this.editPairing = true
        }
        if (this.permission[i] == '6') {
          this.viewReconcile = true
        }
        if (this.permission[i] == '7.1') {
          this.viewResolution = true
        }
        if (this.permission[i] == '7.2') {
          this.editResolution = true
        }
        if (this.permission[i] == '8.1') {
          this.viewLessor = true
        }
        if (this.permission[i] == '8.2') {
          this.editLessor = true
        }
        if (this.permission[i] == '9.1') {
          this.viewLessee = true
        }
        if (this.permission[i] == '9.2') {
          this.editLessee = true
        }
        if (this.permission[i] == '10') {
          this.viewEmployee = true
        }
      }
      if (this.viewOrder == false) {
        this.$router.push('/')
      }
    },
    getCompanyList() {
      this.$http.get(process.env.GET_LESSEE_COMPANY, {
          headers: { 'Asani-Token': localStorage.getItem('jwt') }
        })
        .then(response => {
          if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Ok",
            })
          } else {
            this.companies = response.data.content
          }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
  },
  watch: {
    selectedCompany: function (val) {
      if (val) {
        this.companyName = val
      }
    },
  },
  created() {
    this.loadingTable = true
    this.cekLogin()
    this.cekPermission()
    this.admin = localStorage.getItem('admin_name')
    this.adminId = localStorage.getItem('admin_id')
    if (localStorage.getItem('upgrade-cache')) {
      let cache = JSON.parse(localStorage.getItem('upgrade-cache'))
      this.page = cache.page
      this.itemPerPage = cache.itemPerPage
      this.companyName = cache.companyName
      this.uniqueId = cache.uniqueId
      this.orderCode = cache.orderCode
    }
    this.searchData()
    this.getCompanyList()
  }
}
</script>

<style>
.one-line-sm {
  display: flex;
}

.pagination {
  padding: 0px 0;
}

.pagination ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.pagination a {
  display: inline-block;
  padding: 1px 6px;
  color: #222;
}

.p8 a {
  background-color: #2797FB;
  /*margin: auto 5px;*/
  color: #fff;
  /*font-weight: bold;*/
  border: 1px solid #2797FB;
}

.p8 a:hover {
  text-decoration: none;
}

.p8 a.page:hover {
  text-decoration: none;
  color: #fff;
}

.p8 .is-active {
  background-color: #fff;
  color: #2797FB;
}

.alignleft {
  float: left;
}

.alignright {
  float: right;
}

.pagg {
  display: inline-flex;
  overflow: auto;
}

.total-data {
  padding: 11px 0px;
  font-size: 14px;
  color: #343A40;
}

#wrapperr {
  overflow: auto;
  margin: 5px 3px;
}

#c1 {
  float: left;
}

#c2 {
  float: right;
}

.search-table {
  padding-bottom: 7px;
  margin-top: -5px;
  margin-left: -15px;
}

.active {
  color: #2797FB;
}

.right-dropdown {
  margin-left: 7px;
}

.account-div {
  margin: 2px 2px;
}

.right-arrow {
  margin-left: auto;
}

.brand-logo {
  width: 120px;
}

.menu-title {
  margin-left: 1.125rem;
}

.menu-title-order {
  margin-left: 1.95rem;
}

.menu-title-payment {
  margin-left: 1.525rem;
}

ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  /*width: 200px;*/
  /*background-color: #f1f1f1;*/
}

li.sidebar a {
  display: block;
  color: #000;
  padding: 8px 63px;
  text-decoration: none;
}

li a.active {
  background-color: #4CAF50;
  color: white;
}

li a:hover:not(.active) {
  background-color: #2797FB;
  color: white;
}

.redirect-link {
  text-decoration: underline #2797FB;
  cursor: pointer;
}

.nav-side-menu {
  overflow: auto;
  font-family: verdana;
  font-size: 12px;
  font-weight: 200;
  background-color: #2e353d;
  position: fixed;
  top: 0px;
  width: 300px;
  height: 100%;
  color: #e1ffff;
}

.nav-side-menu .brand {
  background-color: #23282e;
  line-height: 50px;
  display: block;
  text-align: center;
  font-size: 14px;
}

.nav-side-menu .toggle-btn {
  display: none;
}

.nav-side-menu ul,
.nav-side-menu li {
  list-style: none;
  padding: 0px;
  margin: 0px;
  line-height: 35px;
  cursor: pointer;
}

.nav-side-menu ul :not(collapsed) .arrow:before,
.nav-side-menu li :not(collapsed) .arrow:before {
  font-family: FontAwesome;
  content: "\f078";
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  vertical-align: middle;
}

.nav-side-menu ul .active,
.nav-side-menu li .active {
  border-left: 3px solid #d19b3d;
  background-color: #4f5b69;
}

.nav-side-menu ul .sub-menu li.active,
.nav-side-menu li .sub-menu li.active {
  color: #d19b3d;
}

.nav-side-menu ul .sub-menu li.active a,
.nav-side-menu li .sub-menu li.active a {
  color: #d19b3d;
}

.nav-side-menu ul .sub-menu li,
.nav-side-menu li .sub-menu li {
  background-color: #181c20;
  border: none;
  line-height: 28px;
  border-bottom: 1px solid #23282e;
  margin-left: 0px;
}

.nav-side-menu ul .sub-menu li:hover,
.nav-side-menu li .sub-menu li:hover {
  background-color: #020203;
}

.nav-side-menu ul .sub-menu li:before,
.nav-side-menu li .sub-menu li:before {
  font-family: FontAwesome;
  content: "\f105";
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  vertical-align: middle;
}

.nav-side-menu li {
  padding-left: 0px;
  border-left: 3px solid #2e353d;
  border-bottom: 1px solid #23282e;
}

.nav-side-menu li a {
  text-decoration: none;
  color: #e1ffff;
}

.nav-side-menu li a i {
  padding-left: 10px;
  width: 20px;
  padding-right: 20px;
}

.nav-side-menu li:hover {
  border-left: 3px solid #d19b3d;
  background-color: #4f5b69;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;
  -ms-transition: all 1s ease;
  transition: all 1s ease;
}

@media (max-width: 767px) {
  .nav-side-menu {
    position: relative;
    width: 100%;
    margin-bottom: 10px;
  }

  .nav-side-menu .toggle-btn {
    display: block;
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 10 !important;
    padding: 3px;
    background-color: #ffffff;
    color: #000;
    width: 40px;
    text-align: center;
  }

  .brand {
    text-align: left !important;
    font-size: 22px;
    padding-left: 20px;
    line-height: 50px !important;
  }
}

@media (min-width: 767px) {
  .nav-side-menu .menu-list .menu-content {
    display: block;
  }
}

@media (max-width: 573px) {
  .mobile-div {
    padding: 2px 0px;
  }
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.form-control-lg {
  display: block;
  width: 100%;
  min-height: 40px;
  font-size: .8rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-control-lg {
    transition: none;
  }
}

.form-control-lg::-ms-expand {
  background-color: transparent;
  border: 0;
}

.form-control-lg:focus {
  color: #495057;
  background-color: #fff;
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.form-control-lg::-webkit-input-placeholder {
  color: #6c757d;
  opacity: 1;
}

.form-control-lg::-moz-placeholder {
  color: #6c757d;
  opacity: 1;
}

.form-control-lg:-ms-input-placeholder {
  color: #6c757d;
  opacity: 1;
}

.form-control-lg::-ms-input-placeholder {
  color: #6c757d;
  opacity: 1;
}

.form-control-lg::placeholder {
  color: #6c757d;
  opacity: 1;
}

.form-control-lg:disabled,
.form-control-lg[readonly] {
  background-color: #e9ecef;
  opacity: 1;
}

select.form-control-lg:focus::-ms-value {
  color: #495057;
  background-color: #fff;
}

.form-control-lg-file,
.form-control-lg-range {
  display: block;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Order/UpgradeUnit.vue